import { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { AppointmentDetails } from './appointmentDetails';
import { SidePanel } from './sidePanel/sidePanel';

const Wrapper = styled.main`
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const RootLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Wrapper className="flex">
      <div className="flex flex-col flex-1 h-full w-full overflow-hidden">
        <AppointmentDetails />
        <div className="flex-1 w-full h-full overflow-hidden">{children}</div>
      </div>
      <SidePanel />
    </Wrapper>
  );
};

export { RootLayout };
